import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import type DateObject from "react-date-object";
import FormButton from "../../components/FormButton";
import { $api } from "../../helper";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import { formatForSend, requireRules } from "../../helper/method";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import { useNavigate, useSearchParams } from "react-router";
import moment from "moment-jalaali";

export default function AddDiscountCode() {
  const notify = useNotify();
  const { data, isLoading } = $api.useQuery(
    "get",
    "/site-api/v1/discount-code-form/",
  );
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/discount-code/",
  );
  const update = $api.useMutation("put", "/site-api/v1/discount-code/");
  const detail = $api.useMutation("get", "/site-api/v1/discount-code-detail/");
  const [searchParams] = useSearchParams();
  const u_id = searchParams.get("u_id");
  const navigate = useNavigate();
  const [dateValue] = useState<string>("");
  const [valueType, setValueType] = useState("");
  const [form] = Form.useForm();
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("اضافه کردن کد تخفیف");
    if (u_id) {
      detail.mutate({
        params: {
          query: {
            discount_code_u_id: u_id,
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      const update = {
        ...detail.data?.data,
        start_date: moment(detail.data.data.start_date).format("jYYYY/jMM/jDD"),
        end_date: moment(detail.data.data.end_date).format("jYYYY/jMM/jDD"),
      };
      setValueType(update.discount_code_type.toString());
      Object.entries(update).forEach(([key, value]) => {
        form.setFieldValue(key, value);
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      name: string;
      discount_code: string;
      status: number;
      discount_code_type: number;
      amount: number;
      max_amount: number;
      start_date: DateObject;
      end_date: DateObject;
      description: string;
    },
    redirect = true,
  ) => {
    if (u_id) {
      update.mutate(
        {
          body: {
            ...values,
            start_date: formatForSend(values.start_date) ?? "",
            end_date: formatForSend(values.end_date) ?? "",
            discount_code_u_id: u_id,
            max_amount: values.max_amount ? values.max_amount : 0,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/management-discount-code");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      mutate(
        {
          body: {
            ...values,
            start_date: formatForSend(values.start_date) ?? "",
            end_date: formatForSend(values.end_date) ?? "",
            max_amount: values.max_amount ? values.max_amount : 0,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/management-discount-code");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        title="اطلاعات کد تخفیف"
        subTitle="تعریف و تنظیمات پایع مربوط به کد تخفیف"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
          <FormItemInput
            name={"name"}
            rules={requireRules("نام کد تخفیف")}
            label="نام کد تخفیف"
            className="col-span-1"
          />
          <FormItemInput
            name={"discount_code"}
            rules={requireRules("کد تخفیف")}
            label="کد تخفیف"
            className="col-span-1"
          />
          <FormItemInputSelect
            name={"status"}
            rules={requireRules("وضعیت کد تخفیف")}
            inputProps={{
              options: data?.data.statuses?.map((e) => ({
                label: e.number === 1 ? "فعال" : "غیر فعال",
                value: e.number,
              })),
              loading: isLoading,
            }}
            label="نوع"
            className="col-span-1"
          />
          <FormItemInputSelect
            name={"discount_code_type"}
            rules={requireRules("نوع کد تخفیف")}
            inputProps={{
              options: data?.data.types?.map((e) => ({
                label: e.value,
                value: e.number,
              })),
              loading: isLoading,
              onChange: (e) => {
                setValueType(e.toString());
                form.resetFields(["max_amount", "amount"]);
              },
            }}
            label="نوع مقدار"
            className="col-span-1"
          />
          <FormItemInputNumber
            name={"amount"}
            rules={requireRules("مقدار کد تخفیف")}
            label="مقدار"
            className="col-span-1"
            inputProps={{
              max: valueType === "1" ? 100 : undefined,
            }}
          />
          <FormItemInputNumber
            name={"max_amount"}
            label="حداکثر تخفیف"
            rules={[
              {
                required: valueType === "1" ? true : false,
                message: "حداکثر مقدار تخفیف اجباری است",
              },
            ]}
            className="col-span-1"
            inputProps={{
              disabled: valueType === "2" ? true : false,
            }}
          />
          <Form.Item
            name={"start_date"}
            rules={requireRules("تاریخ شروع کد تخفیف")}
            className="mb-0! col-span-1"
            label={"تاریخ شروع"}
          >
            <DatePicker
              value={dateValue}
              name="start_date"
              zIndex={1000}
              // onChange={handleChangeStartDate}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full! z-50! h-11! rounded-lg! border! border-grayscale-200! pr-2!"
              className="w-full! h-full! z-50!"
              containerClassName="!w-full !h-full !z-50"
              format="YYYY/MM/DD"
            ></DatePicker>
          </Form.Item>
          <Form.Item
            name={"end_date"}
            rules={requireRules("تاریخ پایان کد تخفیف")}
            className="col-span-1 mb-0!"
            label={"تاریخ اتمام"}
          >
            <DatePicker
              value={dateValue}
              name="end_date"
              zIndex={1000}
              // onChange={handleChangeStartDate}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full! z-50! h-11! rounded-lg! border! border-grayscale-200! pr-2!"
              className="w-full! h-full! z-50!"
              containerClassName="!w-full !h-full !z-50"
              format="YYYY/MM/DD"
            ></DatePicker>
          </Form.Item>
          <FormItemInputTextarea
            rules={requireRules("توضیحات کد تخفیف")}
            className="sm:col-span-2 col-span-1"
            name={"description"}
            label="توضیحات"
            inputProps={{
              rows: 5,
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
